<!--
Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<div class="login-container">
    <div class="dialog-view-wrapper">
        <div class="view-header">
            <img class="logo-image" src="/assets/img/logo.png" />
            <span class="font-header5 header-text">Playtest Portal</span>
        </div>
        <mat-divider></mat-divider>
        <div class="font-body1">
            The NVIDIA Playtest Portal is where GeForce NOW users can participate in playtests of pre-release and
            released games.
        </div>
        <div class="terms-row">
            <mat-checkbox [(ngModel)]="checkboxState"></mat-checkbox>
            <span class="font-body1"
                >I agree that my participation is subject to the
                <a class="font-body1-link" href="https://www.nvidia.com/en-us/geforce-now/terms-of-use/" target="_blank"
                    >NVIDIA GeForce NOW Terms of Use</a
                >. In addition, I agree that my actions, webcam, and microphone can be monitored live and recorded while
                on this site and during any playtest.</span
            >
        </div>
        <div class="login-button-row">
            <button
                mat-flat-button
                class="font-button2"
                [disabled]="!checkboxState"
                (click)="onClickDoStarfleetLogin()"
            >
                LOG IN
            </button>
        </div>
        <div class="info-text font-body1">
            For more information, please visit
            <a class="font-body1-link" href="http://www.nvidia.com/object/privacy_policy.html" target="_blank"
                >NVIDIA Privacy Policy</a
            >
            and any Developer Playtest Agreements.
        </div>
        <div class="info-text font-body1">
            We also use cookies which are required for the functioning of the web site. See our
            <a class="font-body1-link" href="https://www.nvidia.com/en-us/about-nvidia/cookie-policy/">Cookie Policy</a>
            for further details.
        </div>

        <mat-divider></mat-divider>
        <div class="footer-info">
            <span class="font-sub1"
                >NVIDIA Playtest Portal<span class="font-body2"
                    >&nbsp; | &nbsp;<a
                        class="font-body1-link"
                        href="http://www.nvidia.com/object/legal_info.html"
                        target="_blank"
                        >Legal Information</a
                    ></span
                ></span
            >
            <span class="font-body2">Copyright © 2025 NVIDIA Corporation</span>
        </div>
    </div>
</div>
